export const MemberRegistrationStepConstants = {
    PROOF_PENDING: '05c3cab4-488a-4336-80d2-261343434c66',
    THREE_D_REDIRECT: 'de32848e-18f1-47cf-9c44-349a53b7a033',
    PROOF_UPLOADED: '08099280-59f5-452a-b552-4dc2d96f021e',
    PAYMENT_FAILED: 'd00bd3c9-34e8-40f1-9940-54da889a0892',
    COMPLETE: '7c937252-92ff-4b6a-b121-5dc4c0407c3e',
    PAYMENT: 'f5d9ca5d-72ba-4016-a297-6acc33587056',
    MEMBERSHIP: 'd7b9af50-f9af-4013-ae00-6f89b394577a',
    WELCOME: '2e66539b-b919-4aa5-8af1-84025d79159d',
    OTP: '45858d24-85f7-4d16-92a6-92178e2f41ed'
}